// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_jv-2";
export var aiChatCartContainerExit = "_jv-4";
export var aiChatContainerLarge = "_jv-0";
export var aiChatContainerSmall = "_jv-1";
export var aiChatIcon = "_jv-6";
export var slideInFromRight = "_jv-3";
export var slideOutToRight = "_jv-5";